import React from 'react';
import { Sparkles, Scissors, Palette, ShoppingBag } from 'lucide-react';
import { services } from '../data/mock';

const Services = () => {
  const icons = [Sparkles, Scissors, Palette, ShoppingBag];

  return (
    <section id="services" className="py-20 bg-gradient-to-br from-amber-50 via-cream-50 to-rose-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="section-title mb-4">Our Services</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-rose-400 mx-auto mb-6"></div>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto">
            Discover our comprehensive range of premium fabrics and tailoring services
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const Icon = icons[index];
            return (
              <div 
                key={service.id}
                className="service-card group"
              >
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-amber-400 to-rose-400 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-3 group-hover:text-amber-700 transition-colors duration-300">
                      {service.title}
                    </h3>
                    <p className="text-gray-700 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="inline-block p-8 bg-white rounded-2xl shadow-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Visit Our Store
            </h3>
            <p className="text-lg text-gray-700 mb-6">
              Experience our extensive collection in person at our Hyderpora Chowk location
            </p>
            <button 
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="cta-button"
            >
              Get Directions
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
